module.exports = __webpack_public_path__ + "static/media/>10_selected.f26969a3.png";